import { useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import RichTextEditor from "@/components/RichTextEditor";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export const TemplateEditModal = ({ initial, onClose, onSaved, compact = false }) => {
    const [t, setT] = useState({ name: "", category: "Inne", subject: "", html: "", ...initial });
    const [busy, setBusy] = useState(false);

    const save = async () => {
        setBusy(true);
        try {
            const body = { name: t.name, category: t.category, subject: t.subject, html: t.html };
            if (t.id) await api.put(`/mailing/templates/${t.id}`, body); else await api.post("/mailing/templates", body);
            toast.success("Szablon zapisany.");
            onSaved();
        } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); } finally { setBusy(false); }
    };

    return (
        <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto" onClick={onClose}>
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-2xl p-7 my-8 space-y-4" onClick={(e) => e.stopPropagation()} data-testid="mailing-template-edit-modal">
                <div className="flex items-center justify-between">
                    <h3 className="font-serif text-2xl text-[#092E22]">{t.id ? "Edycja szablonu" : "Nowy szablon"}</h3>
                    <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-gray-100"><X size={18} /></button>
                </div>
                <div className="grid sm:grid-cols-2 gap-3">
                    <div className="space-y-1.5"><Label>Nazwa *</Label><Input value={t.name} onChange={(e) => setT({ ...t, name: e.target.value })} data-testid="mailing-template-name" /></div>
                    <div className="space-y-1.5"><Label>Kategoria</Label><Input value={t.category} onChange={(e) => setT({ ...t, category: e.target.value })} data-testid="mailing-template-category" /></div>
                </div>
                {!compact && (
                    <>
                        <div className="space-y-1.5"><Label>Temat *</Label><Input value={t.subject} onChange={(e) => setT({ ...t, subject: e.target.value })} data-testid="mailing-template-subject" /></div>
                        <div className="space-y-1.5">
                            <Label>Treść</Label>
                            <RichTextEditor value={t.html} onChange={(html) => setT((p) => ({ ...p, html }))} testid="mailing-template-body" />
                        </div>
                    </>
                )}
                <p className="text-xs text-gray-500">Pola do uzupełnienia wpisuj wielkimi literami w nawiasach kwadratowych, np. <code>[DATA]</code>, <code>[GODZINA]</code>, <code>[MIEJSCE]</code>, <code>[KLATKA]</code>.</p>
                <div className="flex justify-end gap-2">
                    <Button variant="outline" onClick={onClose} className="rounded-full">Anuluj</Button>
                    <Button onClick={save} disabled={busy} className="rounded-full bg-[#0D4F3C] hover:bg-[#092E22] text-white" data-testid="mailing-template-save">{busy ? "Zapisywanie…" : "Zapisz szablon"}</Button>
                </div>
            </div>
        </div>
    );
};

export default TemplateEditModal;
